export const HAND_DECISION = {
	UP: 'HAND_UP',
	DOWN: 'HAND_DOWN',
};
